var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-container',{staticClass:"main-index"},[_c('el-main',{staticClass:"content"},[_c('el-aside',{staticClass:"tree-map",attrs:{"width":"180"}},[_c('main-menu')],1),_c('el-main',{staticClass:"right"},[_c('main-content')],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }